// https://egghead.io/lessons/javascript-redux-persisting-the-state-to-the-local-storage

const stateKey = `state.spm.${process.env.PUBLIC_URL}`

export const loadState = () => {
  try {
    const serializedState = sessionStorage.getItem(stateKey)
    if (serializedState == null) {
      return undefined
    }
    return JSON.parse(serializedState)
  } catch (err) {
    return undefined
  }
}

export const saveState = state => {
  try {
    const serializedState = JSON.stringify(state)
    sessionStorage.setItem(stateKey, serializedState)
  } catch (err) {
    // Ignore write errors
  }
}



// WEBPACK FOOTER //
// ../core/src/store/localStorage.js